export default {
  'layout.appBar.userDropdown.nightMode': 'Modo Escuro',
  'layout.appBar.userDropdown.lightMode': 'Modo Claro',
  'layout.appBar.userDropdown.settings': 'Configurações',
  'layout.appBar.userDropdown.logout': 'Sair',
  'layout.appBar.userDropdown.about': 'Sobre a plataforma',
  'layout.appBar.userDropdown.privacy': 'Política de privacidade',
  'layout.appBar.notificationDropdown.notifications': 'Notificações',
  'layout.appBar.notificationDropdown.reminders': 'Lembretes',
  'layout.appBar.notificationDropdown.empty': 'Limpar',
  'layout.appBar.notificationDropdown.seeAll': 'Ver todos',
  'layout.menu.dashboard': 'Home',
  'layout.menu.customers': 'Clientes',
  'layout.menu.indicators': 'Indicadores',
  'layout.menu.customers.create': 'Novo cliente',
  'layout.menu.customers.details': 'Detalhes',
  'layout.menu.customers.details.generalInfo': 'Dados Gerais',
  'layout.menu.customers.details.addresses': 'Endereço',
  'layout.menu.customers.details.contacts': 'Contatos',
  'layout.menu.customers.details.vehicles': 'Veículos',
  'layout.menu.customers.details.bankInfo': 'Dados Bancários',
  'layout.menu.customers.details.servicesHistory': 'Histórico de Serviços',
  'layout.menu.operational': 'Operacional',
  'layout.menu.operational.inventory': 'Estoque',

  'layout.menu.operational.inventory.parts': 'Peças',
  'layout.menu.operational.inventory.parts.create': 'Criar Peça',
  'layout.menu.operational.inventory.parts.details': 'Detalhes da Peça',
  'layout.menu.operational.inventory.parts.details.general': 'Dados Gerais',
  'layout.menu.operational.inventory.parts.details.stock': 'Estoque',
  'layout.menu.operational.inventory.parts.details.application': 'Aplicações',
  'layout.menu.operational.inventory.parts.details.lastPurchases':
    'Últimas compras da peça',
  'layout.menu.operational.inventory.parts.details.replacementParts':
    'Peças Substitutas',
  'layout.menu.operational.inventory.parts.details.latestPartPurchases':
    'Últimas compras da peça',

  'layout.menu.operational.inventory.consumables': 'Insumos',
  'layout.menu.operational.inventory.consumables.create': 'Criar Novo Insumo',
  'layout.menu.operational.inventory.consumables.details.general':
    'Dados Gerais',
  'layout.menu.operational.inventory.consumables.details.stock': 'Estoque',
  'layout.menu.operational.inventory.consumables.details.lastConsumablePurchases':
    'Últimas compras do insumo',
  'layout.menu.operational.inventory.consumables.details.inventory': 'Estoque',
  'layout.menu.operational.inventory.consumables.details.lastPurchases':
    'Últimas compras do insumo',
  'layout.menu.operational.inventory.manufacturers': 'Fabricantes',
  'layout.menu.operational.inventory.groups': 'Grupos',
  'layout.menu.operational.inventory.groups.list': 'Grupos',
  'layout.menu.operational.inventory.groups.create': 'Criar Novo Grupo',
  'layout.menu.operational.inventory.groups.general': 'Dados Gerais',
  'layout.menu.operational.kits': 'Kits',
  'layout.menu.operational.kits.create': 'Criação do Kit',
  'layout.menu.operational.kits.detail': 'Detalhe do Kit',
  'layout.menu.operational.tasks': 'Serviços',
  'layout.menu.operational.tasks.create': 'Criar Novo Serviço',
  'layout.menu.operational.tasks.details': 'Detalhes',
  'layout.menu.operational.tasks.details.general': 'Dados Gerais',
  'layout.menu.operational.tasks.details.applications': 'Aplicações',
  'layout.menu.operational.areas': 'Áreas',
  'layout.menu.operational.areas.create': 'Criar Nova Área',
  'layout.menu.operational.areas.details': 'Detalhes da Área',
  'layout.menu.operational.accessories': 'Acessórios',
  'layout.menu.registry': 'Cadastros',
  'layout.menu.registry.companies': 'Empresas',
  'layout.menu.registry.companies.create': 'Criar Nova Empresa',
  'layout.menu.registry.companies.list': 'Empresas',
  'layout.menu.registry.companies.general': 'Dados Gerais',
  'layout.menu.registry.companies.settings': 'Configurações',
  'layout.menu.registry.companies.customTerms': 'Termos Personalizados',
  'layout.menu.registry.companies.invoice': 'Nota Fiscal',
  'layout.menu.registry.companies.coupon': 'Cupom Fiscal',
  'layout.menu.registry.companies.sintegra': 'Sintegra',
  'layout.menu.registry.companies.settings.priceComposition':
    'Composição de Preço',
  'layout.menu.registry.companies.settings.integrations': 'Integrações',
  'layout.menu.registry.companies.settings.purchase': 'Compras',
  'layout.menu.registry.companies.settings.portoServiceSchedule':
    'Serviços de agendamento Porto',
  'layout.menu.registry.companies.settings.boschCoreCredentials':
    'Credenciais Bosch CoRe',
  'layout.menu.registry.companies.settings.scheduling-config':
    'Configuração de agendamento',
  'layout.menu.registry.companies.settings.profitCostComposition':
    'Composição de Custo e Lucro',
  'layout.menu.registry.companies.settings.itemTags':
    'Tags de itens do Orçamento',
  'layout.menu.registry.companies.settings.financial': 'Financeiro',
  'layout.menu.registry.companies.settings.stoneIntegration':
    'Integração Stone',
  'layout.menu.registry.companies.saveText': 'Salvar',
  'layout.menu.registry.companies.deleteText': 'Excluir Empresa',
  'layout.menu.registry.companies..contract.bankSlips': 'Boletos do contrato',
  'layout.menu.registry.employee': 'Funcionários',
  'layout.menu.registry.employee.create': 'Criar Novo Funcionário',
  'layout.menu.registry.employee.list': 'Funcionários',
  'layout.menu.registry.employee.personal': 'Dados Pessoais',
  'layout.menu.registry.employee.professional': 'Dados Profissionais',
  'layout.menu.registry.employee.contact': 'Contatos',
  'layout.menu.registry.employee.address': 'Endereço',
  'layout.menu.registry.employee.saveText': 'Salvar',
  'layout.menu.registry.employee.deleteText': 'Excluir Funcionário',
  'layout.menu.registry.suppliers': 'Fornecedores',
  'layout.menu.registry.suppliers.create': 'Criar Novo Fornecedor',
  'layout.menu.registry.suppliers.general': 'Geral',
  'layout.menu.registry.suppliers.address': 'Endereço',
  'layout.menu.registry.suppliers.contacts': 'Contatos',
  'layout.menu.registry.suppliers.credit': 'Detalhamento de crédito',
  'layout.menu.registry.suppliers.returnedItems': 'Itens devolvidos',
  'layout.menu.registry.insurers': 'Seguradoras',
  'layout.menu.registry.insurers.create': 'Nova Seguradora',
  'layout.menu.registry.insurers.general': 'Geral',
  'layout.menu.registry.insurers.addresses': 'Endereço',
  'layout.menu.registry.insurers.contacts': 'Contatos',
  'layout.menu.registry.insurers.deleteText': 'Excluir seguradora',
  'layout.menu.registry.insurers.saveText': 'Salvar',
  'layout.menu.registry.insurers.newContact': 'Novo contato',
  'layout.menu.registry.cardAdministrators': 'Administradoras de Cartão',
  'layout.menu.registry.insurers.newAddress': 'Novo endereço',
  'layout.menu.registry.transport': 'Transportadora',
  'layout.menu.registry.transport.create': 'Nova Transportadora',
  'layout.menu.registry.functions': 'Cargos',
  'layout.menu.registry.bankAccounts': 'Contas Bancárias',
  'layout.menu.registry.bankAccounts.create': 'Criar Nova Conta Bancária',
  'layout.menu.registry.billToPay.release.create': 'Criar Nova Conta a Pagar',
  'layout.menu.registry.billToPay.release.detail': 'Detalhes da Parcela',
  'layout.menu.registry.billToPay.release.attachments': 'Anexos da conta',
  'layout.menu.registry.billToRelease.release.create':
    'Criar Nova Conta a Receber',
  'layout.menu.registry.billToRelease.release.detail':
    'Detalhes de Conta a Receber',
  'layout.menu.registry.billToRelease.release.attachments': 'Anexos da Conta',
  'layout.menu.registry.bankEntry.release.create':
    'Criar Novo Lançamento Bancário',
  'layout.menu.registry.bankEntry.release.detail':
    'Detalhes do Lançamento bancário',
  'layout.menu.registry.billToPay.predictions.create': 'Criar Nova Previsão',
  'layout.menu.registry.billToPay.predictions.details': 'Detalhes da Previsão',
  'layout.menu.registry.bankAccounts.details': 'Detalhes da Conta Bancária',
  'layout.menu.registry.bankAccounts.general': 'Detalhes da Conta Bancária',
  'layout.menu.registry.bankAccounts.contacts': 'Contatos da Conta Bancária',
  'layout.menu.registry.bankAccounts.configBankSlip':
    'Configuração do boleto bancário',
  'layout.menu.notifications': 'Notificações',
  'layout.menu.notifications.create': 'Criar Notificações',
  'layout.menu.settings': 'Configurações',
  'layout.menu.settings.account': 'Conta',
  'layout.menu.settings.registration': 'Cadastros',
  'layout.menu.settings.workorderConfiguration': 'Configurações de Orçamento',
  'layout.menu.settings.linkingAccounts': 'Vinculação de contas',
  'layout.menu.settings.financialConfiguration': 'Configuração do Financeiro',
  'layout.menu.settings.tagsWorkOrder': 'Etiquetas para o orçamento',
  'layout.menu.settings.statusWorkOrder': 'Status para o orçamento',
  'layout.menu.settings.tagsdirectSale': 'Etiquetas para a venda direta',
  'layout.menu.settings.tagsAccountsPayableAndReceivable':
    'Etiquetas para Contas a Pagar e Receber',
  'layout.menu.settings.financial': 'Configuração de Financeiro',
  'layout.menu.settings.customer': 'Configurações do Cliente',
  'layout.menu.settings.partsConfiguration': 'Configurações de Peças',
  'layout.menu.settings.system': 'Sistema',
  'layout.menu.settings.profiles': 'Grupos de Usuário',
  'layout.menu.settings.emailSettings': 'Configurações de E-mail',
  'layout.menu.settings.emailUserSettings':
    'Configurações de E-mail do usuário',
  'layout.menu.settings.passwordSettings': 'Configurações de Senha',
  'layout.menu.settings.registrations': 'Cadastros',
  'layout.menu.settings.movements': 'Movimentação',
  'layout.menu.settings.reports': 'Relatório',
  'layout.menu.settings.crm': 'CRM',
  'layout.menu.settings.emailSettingsCrm': 'Configurações de E-mail do CRM',
  'layout.menu.settings.profiles.create': 'Criar novo grupo',
  'layout.menu.settings.profiles.details': 'Detalhes',
  'layout.menu.settings.users': 'Usuários',
  'layout.menu.settings.users.create': 'Criar Novo Usuário',
  'layout.menu.settings.fiscal': 'Fiscal',
  'layout.menu.tax': 'Fiscal',
  'layout.menu.tax.receipt': 'Nota fiscal',
  'layout.menu.settings.whatsapp.templates': 'Templates Whatsapp',
  'layout.menu.settings.stone': 'Stone',
  'layout.menu.settings.integrations': 'Integrações',
  'layout.menu.tax.receipt.general': 'Dados NF-e',
  'layout.menu.tax.receipt.receiver': 'Destinatário',
  'layout.menu.tax.receipt.delivery': 'Entrega',
  'layout.menu.tax.receipt.items': 'Items da nota',
  'layout.menu.tax.receipt.taxes': 'Tributos',
  'layout.menu.tax.receipt.transport': 'Transporte',
  'layout.menu.tax.receipt.payments': 'Formas de pagamento',
  'layout.menu.tax.receipt.additional': 'Dados Adicionais',
  'layout.overview.receivables': 'A receber',
  'layout.overview.payables': 'A pagar',
  'layout.overview.openServices': 'Serviços em aberto',
  'layout.overview.budgets': 'Orçamentos',
  'layout.overview.searchParts': 'Consulta de Peças',
  'layout.overview.newBudget': 'Criar Novo Orçamento',
  'layout.menu.movements': 'Movimentação',
  'layout.menu.movements.budgets.visualManagement': 'Gestão Visual',
  'layout.menu.movements.budgets.generalData': 'Dados Gerais',
  'layout.menu.movements.budgets.partsSupplies': 'Peças e Insumos',
  'layout.menu.movements.budgets.commissions': 'Comissões',

  'layout.menu.movements.workOrders': 'Orçamentos',
  'layout.menu.movements.workOrders.migration': 'Orçamentos Migrados',
  'layout.menu.movements.workOrders.calendar': 'Acompanhamento',
  'layout.menu.movements.workOrders.indicators': 'Indicadores',
  'layout.menu.movements.workOrders.details': 'Detalhes do Orçamento',
  'layout.menu.movements.workOrders.details.import': 'Importação de orçamento',
  'layout.menu.movements.workOrders.details.checklist':
    'Checklist de Orçamento',
  'layout.menu.movements.workOrders.details.checklist.detail':
    'Detalhe do Checklist de Orçamento',
  'layout.menu.movements.workOrders.details.checklist.damages': 'Danos',
  'layout.menu.movements.workOrders.details.checklist.images': 'Imagens',
  'layout.menu.movements.workOrders.details.checklist.observations':
    'Observações',
  'layout.menu.movements.workOrders.details.checklist.accessories':
    'Acessórios',
  'layout.menu.movements.workOrders.details.checklist.requestedServices':
    'Serviços Solicitados',
  'layout.menu.movements.workOrders.details.checklist.quickChecklist':
    'Checklist Rápido',
  'layout.menu.movements.workOrders.details.checklist.complementItems':
    'Itens Complementares',
  'layout.menu.movements.workOrders.details.checklist.futureServices':
    'Serviços Futuros',
  'layout.menu.movements.workOrders.details.generalInfo': 'Dados Gerais',
  'layout.menu.movements.workOrders.details.partsAndTasks': 'Peças e Serviços',
  'layout.menu.movements.workOrders.details.observations': 'Observações',
  'layout.menu.movements.workOrders.details.financial': 'Financeiro',
  'layout.menu.movements.workOrders.details.invoice': 'Nota fiscal',
  'layout.menu.movements.workOrders.details.emails': 'E-mails',
  'layout.menu.movements.workOrders.details.commissions': 'Comissões',

  'layout.menu.movements.directSale': 'Venda Direta',
  'layout.menu.movements.directSale.indicators': 'Indicadores de Venda Direta',
  'layout.menu.movements.directSale.create': 'Criação de Venda Direta',
  'layout.menu.movements.directSale.details': 'Detalhes da Venda Direta',
  'layout.menu.movements.directSale.details.general': 'Dados Gerais',
  'layout.menu.movement.directSale.financial': 'Financeiro',

  'layout.menu.movements.inventory': 'Inventário',
  'layout.menu.movements.inventory.details': 'Detalhes do Inventário',

  'layout.menu.movements.purchases': 'Compras',
  'layout.menu.movements.purchases.releases': 'Lançamentos',
  'layout.menu.movements.purchases.create': 'Nova Compra',
  'layout.menu.movements.purchases.details': 'Detalhes',
  'layout.menu.movements.purchases.details.general': 'Geral',
  'layout.menu.movements.purchases.details.itemsPurchase': 'Itens Compra',
  'layout.menu.movements.purchases.details.itemsPurchase.create':
    'Criação do Item Compra',
  'layout.menu.movements.purchases.details.itemsPurchase.details':
    'Detalhes do Item Compra',
  'layout.menu.movements.purchases.details.data.freight': 'Dados frete',
  'layout.menu.movements.purchases.details.taxes': 'Tributos',
  'layout.menu.movements.purchases.details.groupings': 'Compras Agrupadas',
  'layout.menu.movements.purchases.details.financial': 'Financeiro',
  'layout.menu.movements.purchaseReturn': 'Devolução da Compra',
  'layout.menu.movements.purchases.purchasingGrouping':
    'Agrupamento de Compras',
  'layout.menu.movements.purchases.purchasingImport': 'Importação de Compra',
  'layout.menu.movements.purchases.partsLink24': 'PartsLink24',
  'layout.menu.movements.purchases.wom': 'WOM',
  'layout.menu.movements.purchases.womPurchaseImport':
    'Importação de compra do WOM',
  'layout.menu.movements.purchases.purchasingConfirmImport':
    'Confirmação da importação da compra',

  'layout.menu.movements.deliveryOrReturnOfMaterials':
    'Entrega/Devolução de Materiais',
  'layout.menu.movements.deliveryOrReturnOfMaterials.deliverMaterial':
    'Entregar Material',
  'layout.menu.movements.deliveryOrReturnOfMaterials.returnMaterial':
    'Devolver Material',
  'layout.menu.movements.deliveryOrReturnOfMaterials.delivery': 'Entrega',
  'layout.menu.movements.deliveryOrReturnOfMaterials.return': 'Devolução',

  'layout.menu.movements.diagnostics': 'Diagnósticos',
  'layout.menu.movements.diagnostics.create': 'Novo diagnóstico',
  'layout.menu.movements.diagnostics.details': 'Detalhes do diagnóstico',
  'layout.menu.movements.quotations': 'Cotações',
  'layout.menu.movements.quotations.details': 'Detalhes',
  'layout.menu.movements.quotations.details.items': 'Itens',
  'layout.menu.movements.quotations.details.suppliers': 'Fornecedores',
  'layout.menu.movements.quotations.details.offersConfiguration':
    'Configuração das Ofertas',
  'layout.menu.movements.quotations.details.requestQuotation':
    'Enviar Pedido de Cotação',

  'layout.menu.movements.stockCorrections': 'Correções de Estoque',
  'layout.menu.movements.stockCorrections.create': 'Criar Correção de Estoque',
  'layout.menu.movements.stockCorrections.details':
    'Detalhes da Correção de Estoque',

  'layout.menu.movements.stockTransfer': 'Transferência de estoque',
  'layout.menu.movements.stockTransfer.create':
    'Criação de transferência de estoque',
  'layout.menu.movements.stockTransfer.details':
    'Detalhe de transferência de estoque',

  'layout.menu.movements.employeeCommissions': 'Comissões de funcionários',

  'layout.menu.financial': 'Financeiro',
  'layout.menu.sales': 'Vendas',
  'layout.menu.invoicing': 'Faturamento',
  'layout.menu.financial.accounts': 'Contas',
  'layout.menu.financial.accounts.planAccounts': 'Planos de Contas',
  'layout.menu.financial.accounts.documentTypes': 'Tipos de Documentos',
  'layout.menu.financial.accounts.documentTypes.details':
    'Detalhes do Tipo de Documento',
  'layout.menu.financial.accounts.documentTypes.details.general': 'Geral',
  'layout.menu.financial.accounts.documentTypes.details.rates': 'Parcelas',
  'layout.menu.financial.accounts.paymentConditions': 'Condições de Pagamentos',
  'layout.menu.financial.accounts.costCenters': 'Centro de Custo',

  'layout.menu.financial.billToPay': 'Contas a Pagar',
  'layout.menu.financial.billToPay.releases': 'Lançamentos',
  'layout.menu.financial.billToPay.releases.migration.consult':
    'Lançamentos migrados',
  'layout.menu.financial.billToPay.predictions': 'Previsões',
  'layout.menu.financial.billToPay.grouping': 'Agrupamento',
  'layout.menu.financial.billToPay.calendar': 'Calendário',
  'layout.menu.financial.billToReceive': 'Contas a Receber',
  'layout.menu.financial.billToReceive.releases': 'Lançamento',
  'layout.menu.financial.billToReceive.releases.migration.consult':
    'Lançamentos migrados',
  'layout.menu.financial.billToReceive.grouping': 'Agrupamento',
  'layout.menu.financial.bankEntry': 'Lançamento Bancário',
  'layout.menu.financial.bankEntry.releases': 'Lançamentos',
  'layout.menu.financial.cashMovement': 'Movimento de Caixa',
  'layout.menu.financial.bankSlip': 'Boletos bancários',
  'layout.menu.financial.bankSlipHistory': 'Histórico Boletos',
  'layout.menu.financial.bankSlipHistory.detail': 'Detalhes do boleto',
  'layout.menu.financial.generateShippingFile': 'Gerar Arquivo de Remessa',
  'layout.menu.financial.readReturnFile': 'Ler Arquivo Retorno',
  'layout.menu.financial.bankConciliation': 'Conciliação bancária',

  'layout.menu.fiscal': 'Fiscal',
  'layout.menu.fiscal.ncm': 'NCM',
  'layout.menu.fiscal.ncm.create': 'Criar',
  'layout.menu.fiscal.ncm.details': 'Detalhes',
  'layout.menu.fiscal.coupon': 'Cupom Fiscal (SAT)',
  'layout.menu.fiscal.invoice': 'Nota Fiscal',
  'layout.menu.fiscal.invoice.table.save': 'Salvar',
  'layout.menu.fiscal.invoice.table.cancel': 'Cancelar',
  'layout.menu.fiscal.invoice.referenced': 'Documentos Referenciados',
  'layout.menu.fiscal.invoice.referenced.select.customer': 'Cliente',
  'layout.menu.fiscal.invoice.referenced.select.provider': 'Fornecedor',
  'layout.menu.fiscal.invoice.referenced.select.insuranceCompany': 'Seguradora',
  'layout.menu.fiscal.invoice.referenced.list.fantasyName': 'Nome Fantasia',
  'layout.menu.fiscal.invoice.referenced.list.name': 'Nome',
  'layout.menu.fiscal.invoice.newDocument': 'Novo documento',
  'layout.menu.fiscal.invoice.createNFe': 'Criar NF-e',
  'layout.menu.fiscal.invoice.details': 'Detalhes',
  'layout.menu.fiscal.invoice.detailsNFe': 'Detalhes NF-e',
  'layout.menu.fiscal.invoice.detailsNFCe': 'Detalhes NFC-e',
  'layout.menu.fiscal.invoice.detailsNFSe': 'Detalhes NFS-e',
  'layout.menu.fiscal.invoice.createNFe.datasNFe': 'Dados NF-e',
  'layout.menu.fiscal.invoice.createNFe.additionalData': 'Dados Adicionais',
  'layout.menu.fiscal.invoice.createNFe.cce': 'CC-e',
  'layout.menu.fiscal.invoice.create.recipient': 'Destinatário',
  'layout.menu.fiscal.invoice.createNFCe': 'Criar NFC-e',
  'layout.menu.fiscal.invoice.createNFCe.datasNFCe': 'Dados NFC-e',
  'layout.menu.fiscal.invoice.createNFSe': 'Criar NFS-e',
  'layout.menu.fiscal.invoice.createNFSe.datasNFSe': 'Dados NFS-e',
  'layout.menu.fiscal.invoice.disableNumberingRange':
    'Inutilizar Faixa de Numeração',
  'layout.menu.fiscal.invoice.sped': 'SPED',
  'layout.menu.fiscal.invoice.spedDocuments': 'Documentos',
  'layout.menu.fiscal.invoice.spedDocuments.detail': 'Detalhe do documento',
  'layout.menu.fiscal.invoice.spedConfig': 'Configuração',
  'layout.menu.fiscal.invoice.sintegra': 'Sintegra',
  'layout.menu.fiscal.invoice.downloadXML': 'Baixar Arquivos XML',
  'layout.menu.fiscal.invoice.cfe': 'Cupom Fiscal',
  'layout.menu.fiscal.invoice.manifestationRecipient':
    'Manifestação do Destinatário',

  'layout.menu.fiscal.invoice.cfe.general': 'Dados CF-e',
  'layout.menu.fiscal.invoice.cfe.recipient': 'Destinatário',
  'layout.menu.fiscal.invoice.cfe.items': 'Itens do cupom',
  'layout.menu.fiscal.invoice.cfe.payments': 'Formas de pagamento',

  'layout.menu.schedules': 'Agendamentos',
  'layout.menu.schedules.courtyard': 'Pátio',
  'layout.menu.schedules.accompaniment': 'Acompanhamento',
  'layout.menu.schedules.requests': 'Solicitações',
  'layout.menu.schedules.scheduling': 'Agendamento',
  'layout.menu.schedules.operation': 'Funcionamento',
  'layout.menu.schedules.services': 'Serviços',
  'layout.menu.schedules.customerRating': 'Avaliação de Clientes',
  'layout.menu.schedules.employee': 'Colaborador',

  'layout.menu.informative': 'Informativos',
  'layout.menu.workshopInformation': 'Informativo para oficinas',
  'layout.menu.newsletterDetails': 'Detalhes do informativo',

  'layout.menu.reports': 'Relatórios',
  'layout.menu.reports.movement': 'Movimentação',
  'layout.menu.movement.workOrders': 'Orçamentos',
  'layout.menu.movement.dailyMovement': 'Movimento Diário',
  'layout.menu.movement.directSale': 'Venda Direta',
  'layout.menu.movement.osXFinancial': 'OS x Financeiro',
  'layout.menu.movement.osXInvoice': 'OS x Nota Fiscal',
  'layout.menu.movement.directSaleXFinancial': 'VD x Financeiro',
  'layout.menu.movement.futureServices': 'Serviços futuros',
  'layout.menu.movement.customerWithoutMovement': 'Cliente sem movimentação',
  'layout.menu.movement.vehicleWithoutMovement': 'Veículos sem movimentação',
  'layout.menu.movement.abcCurve': 'Curva ABC',
  'layout.menu.reports.purchases': 'Compras',
  'layout.menu.reports.returnedPurchases': 'Compras Devolvidas',
  'layout.menu.reports.purchases.quotation': 'Cotação',
  'layout.menu.reports.purchases.AbcCurve': 'Curva ABC',
  'layout.menu.reports.stock': 'Estoque',
  'layout.menu.stock.ABCAnalysis': 'Curva ABC',
  'layout.menu.stock.deliveryOfMaterials': 'Entrega de Materiais',
  'layout.menu.stock.consolidated': 'Consolidado',
  'layout.menu.stock.minimumStock': 'Estoque Mínimo',
  'layout.menu.reports.financial': 'Financeiro',
  'layout.menu.financial.billsToPay': 'Contas a Pagar',
  'layout.menu.financial.billsToReceive': 'Contas a Receber',
  'layout.menu.financial.balancete': 'Balancete',
  'layout.menu.financial.cashFlow': 'Fluxo de Caixa',
  'layout.menu.financial.dre': 'Demonstrativo de Resultado',
  'layout.menu.reports.commission': 'Comissão',
  'layout.menu.movement.byMovement': 'Por Movimentação',
  'layout.menu.movement.byFinancial': 'Por Financeiro',
  'layout.menu.reports.productive': 'Produtivo',
  'layout.menu.productive.hoursSold': 'Horas Vendidas',
  'layout.menu.productive.hoursCost': 'Custo da Hora',
  'layout.menu.reports.managerial': 'Gerenciais',
  'layout.menu.managerial.invoicing': 'Faturamento',
  'layout.menu.managerial.cost': 'Custo',
  'layout.menu.managerial.audit': 'Auditoria',
  'layout.menu.managerial.repeatedVehicles': 'Veículos Repetidos',
  'layout.menu.movement.fiscalReport': 'Fiscal',
  'layout.menu.movement.fiscalReport.invoice': 'Nota Fiscal',
  'layout.menu.movement.fiscalReport.invoiceNoteItems': 'Itens da Nota',
  'layout.menu.movement.fiscalReport.invoiceNFSIntallments': 'Parcelas',
  'layout.menu.movement.fiscalReport.invoiceDeductions': 'Deduções',
  'layout.menu.movement.fiscalReport.salesByCST': 'Vendas Por CST',
  'layout.menu.reports.yardManagement': 'Gestão de Pátio',

  'layout.menu.history': 'Histórico',
  'layout.menu.vehicleHistory': 'Histórico de veículos',
  'layout.menu.plateHistory': 'Histórico por placa',
  'layout.menu.emailHistory': 'E-mails enviados',

  'layout.menu.managementCharts': 'Gráficos Gerenciais',

  'layout.menu.crm': 'CRM',
  'layout.menu.crm.shippingOptions': 'Opções de envio',
  'layout.menu.crm.shippingOptions.emailMontage': 'Montagem de e-mail',
  'layout.menu.crm.shippingOptions.customerSelection': 'Seleção de clientes',
  'layout.menu.crm.shippingOptions.finalize': 'Finalizar',
  'layout.menu.crm.searchQuestionnaire': 'Questionário de pesquisa',
  'layout.menu.crm.searchQuestionnaire.create': 'Criar',
  'layout.menu.crm.searchQuestionnaire.details': 'Detalhes',
  'layout.menu.crm.searchQuestionnaire.details.syntheticAnalysis':
    'Análise Sintética',
  'layout.menu.crm.searchQuestionnaire.details.individualAnalysis':
    'Análise Individual',
};
